export function getKeyByValue(object: { [index: string]: any }, value: string): string {
    return Object.keys(object).find(key => object[key] === value) as string;
  }
